import { HttpInterceptorFn } from '@angular/common/http'
import { PcaApiService } from '@services/api/pca-api-base.service'
import { isApiUrl } from '@utils/api-origin.util'

export const HeaderInterceptor: HttpInterceptorFn = (request, next) => {
	// FormData precisa que o browser calcule o Content-Type (com boundary) sozinho;
	// forçar application/json aqui quebra qualquer upload multipart/form-data.
	const isFormData = request.body instanceof FormData

	// Fora das APIs da SilGov (S3, viacep, qualquer outro host) o pedido sai como veio (spec 048).
	if (!isApiUrl(request.url) || isFormData) {
		return next(request)
	}

	const headers = PcaApiService.updateHeaders(request, { 'Content-Type': 'application/json; charset=utf-8' })

	return next(request.clone({ headers }))
}
